const config = {
  reportanalyticsurl: import.meta.env.VITE_REPORT_ANALYTICS_URL,
  localurl: import.meta.env.VITE_LOCAL_URL,
  voiceJwtServerUrl: import.meta.env.VITE_VOICE_JWT_Server_URL,
  domain: import.meta.env.VITE_DOMAIN,
  clientId: import.meta.env.VITE_CLIENT_ID,
  audience: import.meta.env.VITE_AUDIENCE,
  chatAppId: import.meta.env.VITE_CHAT_APP_ID,
  environmentName: import.meta.env.NODE_ENV,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  yotiUrl: import.meta.env.VITE_YOTI_URL,
  externalurl: import.meta.env.VITE_EXTERNAL_URL,
  hotjarId: import.meta.env.VITE_HOTJAR_ID,
  hotjarVersion: import.meta.env.VITE_HOTJAR_VERSION,
  intercomId: import.meta.env.VITE_INTERCOM,
  chameleonKey: import.meta.env.VITE_CHAMELEON,
  idleTime: import.meta.env.VITE_IDLETIME,
  muiKey: import.meta.env.VITE_MUI_KEY,
  autoCutCallTimeout: import.meta.env.VITE_AUTO_CALL_TIMEOUT,
  autoCutCallShowWarningTimeout: import.meta.env
    .VITE_AUTO_CALL_SHOW_WARNING_TIMEOUT,
  userName: import.meta.env.VITE_USER_NAME,
  firstName: import.meta.env.VITE_USER_FIRST_NAME,
  lastName: import.meta.env.VITE_USER_LAST_NAME,
  emailAddress: import.meta.env.VITE_EMAIL_ADDRESS,
  bookingApplication: import.meta.env.VITE_BOOKING_APP_URL,
  deepgramKey: import.meta.env.VITE_DEEPGRAM_KEY,
  intercomMessengerId: import.meta.env.VITE_INTERCOM_ID,
  intercomMessengerRegion: import.meta.env.VITE_INTERCOM_REGION,
  appointmentApp: import.meta.env.VITE_APPOINTMENT_URL,
  intercomMessengerKey: import.meta.env.VITE_INTERCOM_KEY,
  dexDxUrl: import.meta.env.VITE_DEXDX_URL,
  demDxIssuer: import.meta.env.VITE_DEMDX_ISSUER,
  license: import.meta.env.VITE_LICENSE,
  demDxToken: import.meta.env.VITE_DEMDX_TOKEN,
  demDxBase64Url: import.meta.env.VITE_DEMDX_32_BYTE_BASE64URL_KEY,
  demDxJwtEnc: import.meta.env.VITE_DEMDX_JWT_ENC_KID,
  goCardlessID: import.meta.env.VITE_GOCARDLESS_ID,
  goCardlessEnv: import.meta.env.VITE_GOCARDLESS_ENV,
  documentSizeLimitInMbs: import.meta.env.VITE_DOCUMENT_SIZE_IN_MB,
};
export default config;
